import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { textOverflow } from "Utils/Styles";

const classNames = {
  root: `MergeEntryRoot`,
  rootAlt: `MergeEntryRootAlt`,
  label: `MergeEntryLabel`,
  choiceGroup: `MergeEntryChoiceGroup`
};

export function useMergeEntryStyles() {
  const { spacing, semanticColors } = useTheme();

  const styles = useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          padding: spacing.s1
        }
      ],
      rootAlt: [
        classNames.rootAlt,
        {
          backgroundColor: semanticColors.listItemBackgroundHovered,
          padding: spacing.s1
        }
      ],
      label: [
        classNames.label,
        {
          width: `150px`,
          ...textOverflow
        }
      ],
      choiceGroup: [
        classNames.choiceGroup,
        {
          flexGrow: 1,
          width: `auto`,
          overflow: `hidden`,
          "& .ms-ChoiceFieldGroup-flexContainer": {
            display: `flex`,
            flexDirection: `row nowrap`,
            overflow: `hidden`
          },
          "& .ms-ChoiceField": {
            flexGrow: 1,
            margin: 0,
            width: `50%`,
            overflow: `hidden`
          },
          "& .ms-ChoiceField-wrapper": {
            overflow: `hidden`,
            width: `100%`
          },
          "& .ms-ChoiceField-field": {
            width: `95%`,
            overflow: `hidden`,
            selectors: {
              "::before": {
                top: `calc(50% - 10px)`
              },
              ":after": {
                top: `calc(50% - 5px)`
              },
              ":hover::after": {
                top: `calc(50% - 5px)`
              }
            }
          },
          "& .ms-ChoiceFieldLabel": {
            width: `calc(100% - 32px)`,
            ...textOverflow
          }
        }
      ]
    }),
    [spacing, semanticColors]
  );

  const valueStyles = useMemo(
    () => mergeStyleSets({
      root: {
        lineHeight: `18px`,
        paddingLeft: `calc(22px + ${spacing.s1})`,
        width: `calc(100% - 22px + ${spacing.s1})`
      }
    }),
    [spacing]
  );

  return {
    styles,
    valueStyles
  };
}
